// removed by extract-text-webpack-plugin
module.exports = {"layer":"theme__layer___3XmSL","layerItem":"theme__layerItem___2IXXS","layerIcon":"theme__layerIcon___19AM4","dragStart":"theme__dragStart___3_MMR"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Builder/DraggableIconLayer/theme.scss
// module id = 1272
// module chunks = 0